var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4787 5.86719L7.49202 2.41386C7.14183 2.17182 6.7321 2.03019 6.30719 2.00431C5.88228 1.97844 5.4584 2.06931 5.08142 2.26707C4.70445 2.46483 4.38874 2.76194 4.16852 3.12624C3.94829 3.49055 3.83194 3.90817 3.83203 4.33386V11.2405C3.83194 11.6662 3.94829 12.0838 4.16852 12.4481C4.38874 12.8124 4.70445 13.1096 5.08142 13.3073C5.4584 13.5051 5.88228 13.5959 6.30719 13.5701C6.7321 13.5442 7.14183 13.4026 7.49202 13.1605L12.4787 9.7072C12.7895 9.49259 13.0435 9.20575 13.219 8.87132C13.3944 8.53689 13.4861 8.16486 13.4861 7.78719C13.4861 7.40952 13.3944 7.03749 13.219 6.70307C13.0435 6.36864 12.7895 6.0818 12.4787 5.86719V5.86719Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallPlay);
export default __webpack_public_path__ + "static/media/small-play.9e951606cdd6e28c4828d3d6d2456376.svg";
export { ForwardRef as ReactComponent };